import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9fd51758&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderNavigation: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HeaderNavigation/index.vue').default,DesktopNavigationIconSearch: require('/srv/rir-platform/tourism/src/tourism-front/components/common/DesktopNavigationIconSearch/index.vue').default,DesktopNavigationIconLanguage: require('/srv/rir-platform/tourism/src/tourism-front/components/common/DesktopNavigationIconLanguage/index.vue').default,DesktopNavigationIconAvatar: require('/srv/rir-platform/tourism/src/tourism-front/components/common/DesktopNavigationIconAvatar/index.vue').default})
